import { useMutation } from '@tanstack/react-query';
import { suggestMeals } from '@/lib/api/ai';
import type { SuggestMealsRequest } from '@/types/api';

export function useSuggestMeals() {
  return useMutation({
    mutationFn: (data: SuggestMealsRequest) => suggestMeals(data),
  });
}
